import React__default from 'react';
import Checkbox from '../../../../../../node_modules/@mui/material/Checkbox/Checkbox.mjs';
import styled from '../../../../../../node_modules/@mui/material/styles/styled.mjs';
import FormControlLabel from '../../../../../../node_modules/@mui/material/FormControlLabel/FormControlLabel.mjs';

const CheckboxContainer = styled(FormControlLabel)(({ theme })=>({
        display: 'flex',
        alignItems: 'center',
        marginLeft: theme.spacing(-0.25),
        width: 'fit-content',
        gap: theme.spacing(0.5)
    }));
const CheckboxCore = ({ autoFocus, checkboxSx, checked, className, disabled, indeterminate, label, onClick, value })=>{
    const handleChange = (e)=>{
        onClick?.(e.target.checked, e.target.name);
    };
    return /*#__PURE__*/ React__default.createElement(CheckboxContainer, {
        className: className,
        control: /*#__PURE__*/ React__default.createElement(Checkbox, {
            autoFocus: autoFocus,
            checked: checked,
            color: "primary",
            indeterminate: indeterminate,
            name: value,
            onChange: handleChange,
            size: "small",
            sx: checkboxSx
        }),
        disabled: disabled,
        label: label
    });
};

export { CheckboxCore };
//# sourceMappingURL=Checkbox.mjs.map
